export default __webpack_public_path__ + "static/media/bold-icon.94946312.svg";